import React from 'react'
import { object } from 'prop-types'

const VideoStatusLabel = ({status}) => {
  if (status === undefined) {
    return false
  }
  let statusName = status.name
  let labelConfig = {
    playing: {
      type: 'success',
      text: 'ativo'
    },
    paused: {
      type: 'danger',
      text: 'pausado'
    }
  }
  let labelType = labelConfig[statusName]['type']
  let labelText = labelConfig[statusName]['text']
  return (
    <small className='campaign-status'>
      <span className={`label label-${labelType}`}>{labelText}</span>
    </small>
  )
}

VideoStatusLabel.propTypes = {
  status: object
}

export default VideoStatusLabel



// WEBPACK FOOTER //
// ./src/components/VideoStatusLabel.js